<template>
  <div class="deck-share">
    <h2 class="title is-4">Share this Slide Deck</h2>
    <!-- <p class="m-b-30">Use this link to share your deck’s preview page. Anyone with this link can see an overview of your slide deck and create a copy of this deck in their own account.</p> -->
    <!-- <p class="m-b-30">Use this link to share a preview page that has an overview of your slide deck and lets your firneds and coworkers copy this deck into their own account.</p> -->
    <p class="m-b-30">Share your deck's preview page to let anyone see an overview and create a copy in their own account.</p>

    <b-switch v-model="localIsPublic" @input="setPublicOrPrivate($event)" :disabled="!isOwner">{{ localIsPublic ? 'Public (anyone with the link can view)' : 'This deck is private (not shareable)' }}</b-switch>
    <p v-if="!localIsPublic" class="m-t-30 notification is-one-line is-small is-light">
      <i class="fas fa-info-circle is-small is-size-6 m-r-5" />
      <span class="is-size-6">Set this deck to public to create a share link</span>
    </p>

    <template v-if="localIsPublic">
      <b-field class="m-t-30">
        <b-input ref="copy" :value="shareUrl" type="text" readonly expanded />
        <div class="control">
          <p @click="copyText(shareUrl)" class="button is-primary">copy</p>
        </div>
      </b-field>

      <a :href="shareUrl" class="m-t-20 is-size-6" target="_blank">Preview your sharing page</a>
    </template>
  </div>
</template>

<script>
import { setPublicOrPrivate } from '~/queries/deckQueries.gql'

export default {
  props: ['deckId', 'ownerId', 'isPublic'],
  data () {
    return {
      localIsPublic: false
    }
  },
  computed: {
    id () {
      return this.deckId || this.$route.params.id
    },
    shareUrl () {
      return 'https://slideswith.com/preview/' + this.id
    },
    isOwner () {
      return this.$auth.user.id === this.ownerId
    }
  },
  created () {
    this.localIsPublic = this.isPublic
  },
  methods: {
    async setPublicOrPrivate (val) {
      if (!this.isOwner) {
        this.$buefy.toast.open('Only the owner can change deck sharing')
        return
      }
      await this.$apollo.mutate({
        mutation: setPublicOrPrivate,
        variables: {
          id: this.id,
          isPublic: val
        }
      })
      this.$emit('refresh:decks')
    },
    copyText (text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      input.remove()
      this.$buefy.toast.open({ message: 'copied!', type: 'is-primary' })
    }
  }
}
</script>

<style lang="scss" scoped>
.deck-share {
  background-color: white;
  padding: 40px;
  border-radius: 6px;
}
</style>
